var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "academy-common-lib": "static-1.14370"
    },
    "depPathPrefixes": {
      "academy-common-lib": "/academy-common-lib/static-1.14370"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.33967",
    "project": "academy-common-lib",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};